import React from 'react'
import './DateForm.scss'
import DatePicker from 'react-16-bootstrap-date-picker'
import moment from 'moment'

class DateForm extends React.Component {
  onStartChange (date) {
    this.props.onChange(moment(new Date(date)).format("YYYY-MM-DD"))
  }
  render() {
    return (
      <div className='date-form'>
        <label>{this.props.schema.title}</label>
        <DatePicker  showClearButton={false} value={this.props.formData} onChange={this.onStartChange.bind(this)} />
      </div>
    );
  }
}

export default DateForm



// WEBPACK FOOTER //
// ./src/views/components/DateForm/index.js